module.exports = __webpack_public_path__ + "static/img/5-3.10f47de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/5-3.jpg
// module id = xREL
// module chunks = 0